module.exports = __webpack_public_path__ + "static/user-list-one-color-do-332a7f89ad723152b615c905f2175256.png";